<template>
  <div
    v-if="canUpdatePages"
    class="toolbar-overlay"
    :class="[
      `el-${type}`,
      { active: hovered || selected },
      { pressed: selected }
    ]"
    @click="handleClick"
  >
    <div class="toolbar-frame">
      <div
        v-if="!hideControls"
        class="toolbar-header"
      >
        <div
          v-if="!hideControlsLeft"
          class="toolbar-header-left"
        >
          <div
            v-if="!hideActions.includes('move')"
            class="toolbar-icon toolbar-icon--drag move"
          >
            <svg
              fill="none"
              height="14"
              viewBox="0 0 14 14"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
              class="toolbar-icon-svg"
            >
              <path
                d="M8.32215 3.37761C8.54706 3.60252 8.91171 3.60252 9.13661 3.37762C9.36152 3.15271 9.36152 2.78806 9.13661 2.56316L7.40889 0.835428C7.30088 0.727424 7.1544 0.666748 7.00166 0.666748C6.84892 0.666748 6.70243 0.727424 6.59443 0.835428L4.8667 2.56316C4.64179 2.78806 4.64179 3.15271 4.8667 3.37761C5.09161 3.60252 5.45625 3.60252 5.68116 3.37761L6.42575 2.63303V5.27402C6.42575 5.59209 6.68359 5.84993 7.00166 5.84993C7.31972 5.84993 7.57757 5.59209 7.57757 5.27402V2.63303L8.32215 3.37761Z"
                fill="currentColor"
              />
              <path
                d="M6.59443 13.1681C6.70243 13.2761 6.84892 13.3367 7.00166 13.3367C7.1544 13.3367 7.30088 13.2761 7.40889 13.1681L9.13661 11.4403C9.36152 11.2154 9.36152 10.8508 9.13661 10.6259C8.91171 10.401 8.54706 10.401 8.32215 10.6259L7.57757 11.3705V8.72948C7.57757 8.41141 7.31972 8.15357 7.00166 8.15357C6.68359 8.15357 6.42575 8.41141 6.42575 8.72948V11.3705L5.68116 10.6259C5.45625 10.401 5.09161 10.401 4.8667 10.6259C4.6418 10.8508 4.6418 11.2154 4.8667 11.4403L6.59443 13.1681Z"
                fill="currentColor"
              />
              <path
                d="M3.37752 5.68125C3.60243 5.45634 3.60243 5.0917 3.37752 4.86679C3.15262 4.64189 2.78797 4.64189 2.56306 4.86679L0.835336 6.59452C0.727332 6.70252 0.666656 6.84901 0.666656 7.00175C0.666656 7.15449 0.727333 7.30097 0.835337 7.40898L2.56306 9.13671C2.78797 9.36161 3.15262 9.36161 3.37752 9.13671C3.60243 8.9118 3.60243 8.54715 3.37752 8.32225L2.63293 7.57766H5.27393C5.592 7.57766 5.84984 7.31982 5.84984 7.00175C5.84984 6.68368 5.592 6.42584 5.27393 6.42584H2.63293L3.37752 5.68125Z"
                fill="currentColor"
              />
              <path
                d="M11.3704 7.57766L10.6258 8.32225C10.4009 8.54715 10.4009 8.9118 10.6258 9.13671C10.8507 9.36161 11.2153 9.36161 11.4402 9.13671L13.168 7.40898C13.276 7.30097 13.3367 7.15449 13.3367 7.00175C13.3367 6.84901 13.276 6.70252 13.168 6.59452L11.4402 4.86679C11.2153 4.64189 10.8507 4.64189 10.6258 4.86679C10.4009 5.0917 10.4009 5.45634 10.6258 5.68125L11.3704 6.42584H8.72938C8.41132 6.42584 8.15347 6.68368 8.15347 7.00175C8.15347 7.31982 8.41132 7.57766 8.72938 7.57766H11.3704Z"
                fill="currentColor"
              />
            </svg>
          </div>

          <input
            v-if="!hideActions.includes('name')"
            v-model="label"
            type="text"
            class="toolbar-name-input"
          >

          <div
            v-if="!hideActions.includes('move')"
            class="toolbar-move-buttons"
          >
            <button
              class="toolbar-icon-button"
              @click.stop="handleMoveUp"
            >
              <svg
                fill="none"
                height="12"
                viewBox="0 0 8 12"
                width="8"
                xmlns="http://www.w3.org/2000/svg"
                class="toolbar-icon-svg-up"
              >
                <path
                  clip-rule="evenodd"
                  d="M3.88456 11.8101C4.3695 11.8101 4.76263 11.4169 4.76263 10.932L4.76263 2.64608L6.51962 4.44129C6.7956 4.72387 7.24704 4.7241 7.52308 4.44161C7.79509 4.16362 7.79464 3.7159 7.5234 3.43797L4.36537 0.210524C4.09095 -0.0699272 3.63606 -0.0703659 3.36155 0.210845L0.203833 3.43801C-0.0681682 3.716 -0.067729 4.16373 0.20352 4.44165C0.479879 4.7241 0.930981 4.72441 1.20734 4.44197L3.00649 2.60323L3.00649 10.932C3.00649 11.4169 3.39962 11.8101 3.88456 11.8101Z"
                  fill="currentColor"
                  fill-rule="evenodd"
                />
              </svg>
            </button>

            <button
              class="toolbar-icon-button"
              @click.stop="handleMoveDown"
            >
              <svg
                fill="none"
                height="12"
                viewBox="0 0 8 12"
                width="8"
                xmlns="http://www.w3.org/2000/svg"
                class="toolbar-icon-svg-down"
              >
                <path
                  clip-rule="evenodd"
                  d="M3.84441 0.122559C3.35946 0.122559 2.96634 0.515683 2.96634 1.00063V9.2866L1.2093 7.49132C0.933309 7.20874 0.481871 7.20852 0.205827 7.49101C-0.066174 7.76899 -0.0657323 8.21672 0.205516 8.49464L3.36354 11.7221C3.63796 12.0025 4.09285 12.003 4.36736 11.7218L7.52508 8.49461C7.79708 8.21662 7.79664 7.76889 7.52539 7.49097C7.24903 7.20852 6.79793 7.2082 6.52157 7.49065L4.72248 9.32933V1.00063C4.72248 0.515683 4.32935 0.122559 3.84441 0.122559Z"
                  fill="currentColor"
                  fill-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>

        <div
          v-if="!hideControlsRight"
          class="toolbar-header-right"
        >
          <button
            v-if="!hideActions.includes('duplicate')"
            class="toolbar-icon-button"
            @click.stop="handleDuplicate"
          >
            <svg
              fill="none"
              height="13"
              viewBox="0 0 14 13"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
              class="toolbar-icon-svg"
            >
              <path
                d="M9.31857 12.5714H2.31857C1.57657 12.5714 0.972412 11.9957 0.972412 11.2885V4.10434C0.972412 3.3972 1.57657 2.82144 2.31857 2.82144H2.85703C3.00564 2.82144 3.12626 2.93639 3.12626 3.07802C3.12626 3.21965 3.00564 3.3346 2.85703 3.3346H2.31857C1.87326 3.3346 1.51087 3.67995 1.51087 4.10434V11.2885C1.51087 11.7129 1.87326 12.0583 2.31857 12.0583H9.31857C9.76387 12.0583 10.1263 11.7129 10.1263 11.2885V10.7754C10.1263 10.6338 10.2469 10.5188 10.3955 10.5188C10.5441 10.5188 10.6647 10.6338 10.6647 10.7754V11.2885C10.6647 11.9957 10.0606 12.5714 9.31857 12.5714Z"
                fill="none"
                stroke="currentColor"
                stroke-width="0.3"
              />
              <path
                clip-rule="evenodd"
                d="M2.31851 2.99287C1.66461 2.99287 1.14466 3.49875 1.14466 4.10433V11.2885C1.14466 11.8941 1.66461 12.4 2.31851 12.4H9.31851C9.97241 12.4 10.4924 11.8941 10.4924 11.2885V10.7754C10.4924 10.7353 10.4559 10.6902 10.3954 10.6902C10.3349 10.6902 10.2985 10.7353 10.2985 10.7754V11.2885C10.2985 11.8145 9.85192 12.2297 9.31851 12.2297H2.31851C1.7851 12.2297 1.33851 11.8145 1.33851 11.2885V4.10433C1.33851 3.5784 1.7851 3.16317 2.31851 3.16317H2.85697C2.91749 3.16317 2.9539 3.1181 2.9539 3.07802C2.9539 3.03794 2.91749 2.99287 2.85697 2.99287H2.31851ZM0.800049 4.10433C0.800049 3.29565 1.48841 2.65001 2.31851 2.65001H2.85697C3.09369 2.65001 3.29851 2.83483 3.29851 3.07802C3.29851 3.3212 3.09369 3.50602 2.85697 3.50602H2.31851C1.9613 3.50602 1.68313 3.7815 1.68313 4.10433V11.2885C1.68313 11.6114 1.96131 11.8869 2.31851 11.8869H9.31851C9.67572 11.8869 9.9539 11.6114 9.9539 11.2885V10.7754C9.9539 10.5322 10.1587 10.3474 10.3954 10.3474C10.6322 10.3474 10.837 10.5322 10.837 10.7754V11.2885C10.837 12.0972 10.1486 12.7429 9.31851 12.7429H2.31851C1.48841 12.7429 0.800049 12.0972 0.800049 11.2885V4.10433Z"
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-width="0.3"
              />
              <path
                clip-rule="evenodd"
                d="M5.59135 9.57144H11.6995C12.4647 9.57144 13.0877 9.01044 13.0877 8.32144V1.82144C13.0877 1.13244 12.4647 0.571442 11.6995 0.571442H5.59135C4.82616 0.571442 4.20312 1.13244 4.20312 1.82144V8.32144C4.20312 9.01044 4.82616 9.57144 5.59135 9.57144ZM4.75841 1.82144C4.75841 1.40794 5.13212 1.07144 5.59135 1.07144H11.6995C12.1587 1.07144 12.5325 1.40794 12.5325 1.82144V8.32144C12.5325 8.73494 12.1587 9.07144 11.6995 9.07144H5.59135C5.13212 9.07144 4.75841 8.73494 4.75841 8.32144V1.82144Z"
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-width="0.3"
              />
              <path
                clip-rule="evenodd"
                d="M5.59129 0.742866C4.90469 0.742866 4.37538 1.24281 4.37538 1.82144V8.32144C4.37538 8.90007 4.90469 9.40001 5.59129 9.40001H11.6995C12.3861 9.40001 12.9154 8.90007 12.9154 8.32144V1.82144C12.9154 1.24281 12.3861 0.742866 11.6995 0.742866H5.59129ZM4.03076 1.82144C4.03076 1.02207 4.74752 0.400009 5.59129 0.400009H11.6995C12.5432 0.400009 13.26 1.02207 13.26 1.82144V8.32144C13.26 9.1208 12.5432 9.74286 11.6995 9.74286H5.59129C4.74752 9.74286 4.03076 9.1208 4.03076 8.32144V1.82144ZM4.58605 1.82144C4.58605 1.29757 5.05348 0.900009 5.59129 0.900009H11.6995C12.2373 0.900009 12.7047 1.29757 12.7047 1.82144V8.32144C12.7047 8.8453 12.2373 9.24286 11.6995 9.24286H5.59129C5.05348 9.24286 4.58605 8.8453 4.58605 8.32144V1.82144ZM5.59129 1.24287C5.21065 1.24287 4.93067 1.51831 4.93067 1.82144V8.32144C4.93067 8.62457 5.21065 8.90001 5.59129 8.90001H11.6995C12.0801 8.90001 12.3601 8.62457 12.3601 8.32144V1.82144C12.3601 1.51831 12.0801 1.24287 11.6995 1.24287H5.59129Z"
                fill="currentColor"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-width="0.3"
              />
            </svg>
          </button>

          <button
            v-if="!hideActions.includes('favorite')"
            class="toolbar-icon-button"
            @click.stop="handleFavorite"
          >
            <svg
              fill="none"
              height="15"
              viewBox="0 0 15 15"
              width="15"
              xmlns="http://www.w3.org/2000/svg"
              class="toolbar-icon-svg"
            >
              <path
                clip-rule="evenodd"
                d="M7.48549 11.2381L4.09557 13.0922L4.74299 9.16518L2.00049 6.38403L5.79053 5.81108L7.48549 2.23813L9.18045 5.81108L12.9705 6.38403L10.228 9.16518L10.8754 13.0922L7.48549 11.2381Z"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-width="1.3"
              />
            </svg>
          </button>

          <delete-confirm
            v-if="!hideActions.includes('delete')"
            title="Are you sure?"
            description="Are you sure you want to delete this section?"
            class="inline-flex"
            @confirm="handleDelete"
          >
            <template #activator="{on}">
              <button
                class="toolbar-icon-button"
                v-on="on"
              >
                <svg
                  fill="none"
                  height="15"
                  viewBox="0 0 15 15"
                  width="15"
                  xmlns="http://www.w3.org/2000/svg"
                  class="toolbar-icon-svg"
                >
                  <path
                    clip-rule="evenodd"
                    d="M9.66667 0.857147H5.33333C4.85469 0.857147 4.46667 1.2409 4.46667 1.71429V2.57143H1.21667C1.097 2.57143 1 2.66737 1 2.78572V3.21429C1 3.33264 1.097 3.42857 1.21667 3.42857H2.08333L3.1294 14.184C3.1509 14.4045 3.33876 14.5724 3.56273 14.5714H11.4425C11.6664 14.5724 11.8543 14.4045 11.8758 14.184L12.9167 3.42857H13.7833C13.903 3.42857 14 3.33264 14 3.21429V2.78572C14 2.66737 13.903 2.57143 13.7833 2.57143H10.5333V1.71429C10.5333 1.2409 10.1453 0.857147 9.66667 0.857147ZM12.0465 3.42857L11.0455 13.7143H3.95446L2.95346 3.42857H12.0465ZM9.66667 1.71429H5.33334V2.57144H9.66667V1.71429Z"
                    fill="currentColor"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M4.46667 2.57143V2.72143H4.61667V2.57143H4.46667ZM2.08333 3.42857L2.23263 3.41405L2.21945 3.27857H2.08333V3.42857ZM3.1294 14.184L2.9801 14.1985L2.98011 14.1986L3.1294 14.184ZM3.56273 14.5714V14.4214L3.56205 14.4214L3.56273 14.5714ZM11.4425 14.5714L11.4432 14.4214H11.4425V14.5714ZM11.8758 14.184L12.0251 14.1986L12.0251 14.1984L11.8758 14.184ZM12.9167 3.42857V3.27857H12.7805L12.7674 3.41413L12.9167 3.42857ZM10.5333 2.57143H10.3833V2.72143H10.5333V2.57143ZM11.0455 13.7143V13.8643H11.1816L11.1948 13.7288L11.0455 13.7143ZM12.0465 3.42857L12.1958 3.4431L12.2118 3.27857H12.0465V3.42857ZM3.95446 13.7143L3.80517 13.7288L3.81835 13.8643H3.95446V13.7143ZM2.95346 3.42857V3.27857H2.78816L2.80417 3.4431L2.95346 3.42857ZM5.33334 1.71429V1.56429H5.18334V1.71429H5.33334ZM9.66667 1.71429H9.81667V1.56429H9.66667V1.71429ZM5.33334 2.57144H5.18334V2.72144H5.33334V2.57144ZM9.66667 2.57144V2.72144H9.81667V2.57144H9.66667ZM5.33333 1.00715H9.66667V0.707147H5.33333V1.00715ZM4.61667 1.71429C4.61667 1.3253 4.93596 1.00715 5.33333 1.00715V0.707147C4.77341 0.707147 4.31667 1.1565 4.31667 1.71429H4.61667ZM4.61667 2.57143V1.71429H4.31667V2.57143H4.61667ZM1.21667 2.72143H4.46667V2.42143H1.21667V2.72143ZM1.15 2.78572C1.15 2.75177 1.17828 2.72143 1.21667 2.72143V2.42143C1.01573 2.42143 0.85 2.58297 0.85 2.78572H1.15ZM1.15 3.21429V2.78572H0.85V3.21429H1.15ZM1.21667 3.27857C1.17828 3.27857 1.15 3.24823 1.15 3.21429H0.85C0.85 3.41704 1.01573 3.57857 1.21667 3.57857V3.27857ZM2.08333 3.27857H1.21667V3.57857H2.08333V3.27857ZM3.2787 14.1695L2.23263 3.41405L1.93404 3.4431L2.9801 14.1985L3.2787 14.1695ZM3.56205 14.4214C3.41418 14.4221 3.29254 14.3115 3.27869 14.1694L2.98011 14.1986C3.00926 14.4975 3.26333 14.7228 3.56342 14.7214L3.56205 14.4214ZM11.4425 14.4214H3.56273V14.7214H11.4425V14.4214ZM11.7265 14.1694C11.7127 14.3115 11.591 14.4221 11.4432 14.4214L11.4418 14.7214C11.7419 14.7228 11.9959 14.4975 12.0251 14.1986L11.7265 14.1694ZM12.7674 3.41413L11.7265 14.1695L12.0251 14.1984L13.066 3.44302L12.7674 3.41413ZM13.7833 3.27857H12.9167V3.57857H13.7833V3.27857ZM13.85 3.21429C13.85 3.24823 13.8217 3.27857 13.7833 3.27857V3.57857C13.9843 3.57857 14.15 3.41704 14.15 3.21429H13.85ZM13.85 2.78572V3.21429H14.15V2.78572H13.85ZM13.7833 2.72143C13.8217 2.72143 13.85 2.75177 13.85 2.78572H14.15C14.15 2.58297 13.9843 2.42143 13.7833 2.42143V2.72143ZM10.5333 2.72143H13.7833V2.42143H10.5333V2.72143ZM10.3833 1.71429V2.57143H10.6833V1.71429H10.3833ZM9.66667 1.00715C10.064 1.00715 10.3833 1.3253 10.3833 1.71429H10.6833C10.6833 1.1565 10.2266 0.707147 9.66667 0.707147V1.00715ZM11.1948 13.7288L12.1958 3.4431L11.8972 3.41404L10.8962 13.6998L11.1948 13.7288ZM3.95446 13.8643H11.0455V13.5643H3.95446V13.8643ZM2.80417 3.4431L3.80517 13.7288L4.10376 13.6998L3.10276 3.41404L2.80417 3.4431ZM12.0465 3.27857H2.95346V3.57857H12.0465V3.27857ZM5.33334 1.86429H9.66667V1.56429H5.33334V1.86429ZM5.48334 2.57144V1.71429H5.18334V2.57144H5.48334ZM9.66667 2.42144H5.33334V2.72144H9.66667V2.42144ZM9.51667 1.71429V2.57144H9.81667V1.71429H9.51667Z"
                    fill="currentColor"
                  />
                  <path
                    clip-rule="evenodd"
                    d="M7.71667 12.4192H7.28334C7.22581 12.4194 7.17056 12.3969 7.12988 12.3567C7.0892 12.3164 7.06644 12.2618 7.06667 12.2049V4.88488C7.06667 4.76653 7.16368 4.67059 7.28334 4.67059H7.71667C7.83633 4.67059 7.93334 4.76653 7.93334 4.88488V12.2049C7.93357 12.2618 7.91082 12.3164 7.87013 12.3567C7.82945 12.3969 7.77421 12.4194 7.71667 12.4192ZM6.00154 12.4057L5.56821 12.4305C5.44895 12.4374 5.34643 12.3478 5.33854 12.23L4.84367 4.92538C4.83988 4.86875 4.85904 4.81295 4.89694 4.77033C4.93483 4.7277 4.98833 4.70176 5.04561 4.69824L5.47894 4.67252C5.59852 4.66519 5.70159 4.75486 5.70947 4.87309L6.20434 12.1777C6.21177 12.2956 6.12161 12.3974 6.00241 12.4057H6.00154ZM9.43179 12.4305L8.99846 12.4057H8.99759C8.87839 12.3974 8.78823 12.2956 8.79566 12.1777L9.29053 4.8731C9.29841 4.75486 9.40148 4.66519 9.52106 4.67252L9.95439 4.69824C10.0117 4.70176 10.0652 4.7277 10.1031 4.77033C10.141 4.81295 10.1601 4.86875 10.1563 4.92538L9.66146 12.23C9.65357 12.3478 9.55104 12.4374 9.43179 12.4305Z"
                    fill="currentColor"
                    fill-rule="evenodd"
                  />
                  <path
                    d="M7.28334 12.4192V12.2692L7.28274 12.2692L7.28334 12.4192ZM7.71667 12.4192L7.71727 12.2692H7.71667V12.4192ZM7.06667 12.2049L7.21668 12.2055V12.2049H7.06667ZM7.93334 12.2049H7.78334L7.78334 12.2055L7.93334 12.2049ZM5.56821 12.4305L5.55962 12.2808L5.55961 12.2808L5.56821 12.4305ZM6.00154 12.4057V12.2554L5.99295 12.2559L6.00154 12.4057ZM5.33854 12.23L5.48821 12.2199L5.4882 12.2198L5.33854 12.23ZM4.84367 4.92538L4.69401 4.93542L4.69402 4.93552L4.84367 4.92538ZM4.89694 4.77033L5.00904 4.86999L5.00904 4.86999L4.89694 4.77033ZM5.04561 4.69824L5.03672 4.5485L5.0364 4.54852L5.04561 4.69824ZM5.47894 4.67252L5.48782 4.82226L5.48813 4.82224L5.47894 4.67252ZM5.70947 4.87309L5.5598 4.88308L5.55982 4.88323L5.70947 4.87309ZM6.20434 12.1777L6.35404 12.1682L6.35399 12.1675L6.20434 12.1777ZM6.00241 12.4057V12.556L6.01276 12.5553L6.00241 12.4057ZM8.99846 12.4057L9.00707 12.2557H8.99846V12.4057ZM9.43179 12.4305L9.44039 12.2808L9.44038 12.2808L9.43179 12.4305ZM8.99759 12.4057L8.98722 12.5557H8.99759V12.4057ZM8.79566 12.1777L8.646 12.1675L8.64596 12.1682L8.79566 12.1777ZM9.29053 4.8731L9.44018 4.88323L9.4402 4.88308L9.29053 4.8731ZM9.52106 4.67252L9.51187 4.82224L9.51218 4.82226L9.52106 4.67252ZM9.95439 4.69824L9.9636 4.54852L9.96328 4.5485L9.95439 4.69824ZM10.1031 4.77033L9.99096 4.86999L9.99096 4.86999L10.1031 4.77033ZM10.1563 4.92538L10.306 4.93552L10.306 4.93542L10.1563 4.92538ZM9.66146 12.23L9.5118 12.2198L9.51179 12.2199L9.66146 12.23ZM7.28334 12.5692H7.71667V12.2692H7.28334V12.5692ZM7.0244 12.4633C7.09349 12.5316 7.18695 12.5695 7.28394 12.5692L7.28274 12.2692C7.26467 12.2692 7.24764 12.2621 7.23536 12.25L7.0244 12.4633ZM6.91668 12.2043C6.91628 12.3017 6.95526 12.3949 7.0244 12.4633L7.23536 12.25C7.22313 12.2379 7.21661 12.2219 7.21667 12.2055L6.91668 12.2043ZM6.91667 4.88488V12.2049H7.21668V4.88488H6.91667ZM7.28334 4.52059C7.0824 4.52059 6.91667 4.68213 6.91667 4.88488H7.21668C7.21668 4.85093 7.24496 4.82059 7.28334 4.82059V4.52059ZM7.71667 4.52059H7.28334V4.82059H7.71667V4.52059ZM8.08334 4.88488C8.08334 4.68213 7.91761 4.52059 7.71667 4.52059V4.82059C7.75506 4.82059 7.78334 4.85093 7.78334 4.88488H8.08334ZM8.08334 12.2049V4.88488H7.78334V12.2049H8.08334ZM7.97561 12.4633C8.04476 12.3949 8.08373 12.3017 8.08334 12.2043L7.78334 12.2055C7.78341 12.2219 7.77688 12.2379 7.76466 12.25L7.97561 12.4633ZM7.71608 12.5692C7.81307 12.5695 7.90653 12.5316 7.97561 12.4633L7.76466 12.25C7.75238 12.2621 7.73535 12.2692 7.71727 12.2692L7.71608 12.5692ZM5.5768 12.5803L6.01013 12.5554L5.99295 12.2559L5.55962 12.2808L5.5768 12.5803ZM5.18887 12.24C5.20236 12.4415 5.37693 12.5918 5.5768 12.5803L5.55961 12.2808C5.52098 12.283 5.4905 12.2542 5.48821 12.2199L5.18887 12.24ZM4.69402 4.93552L5.18888 12.2401L5.4882 12.2198L4.99333 4.91524L4.69402 4.93552ZM4.78483 4.67066C4.72036 4.74318 4.68751 4.83844 4.69401 4.93542L4.99334 4.91534C4.99225 4.89905 4.99772 4.88272 5.00904 4.86999L4.78483 4.67066ZM5.0364 4.54852C4.93983 4.55446 4.84925 4.59821 4.78483 4.67066L5.00904 4.86999C5.02041 4.85719 5.03683 4.84906 5.05481 4.84795L5.0364 4.54852ZM5.47005 4.52279L5.03672 4.5485L5.05449 4.84797L5.48782 4.82226L5.47005 4.52279ZM5.85914 4.86311C5.84566 4.661 5.67017 4.51051 5.46975 4.5228L5.48813 4.82224C5.52687 4.81986 5.55751 4.84872 5.5598 4.88308L5.85914 4.86311ZM6.35399 12.1675L5.85913 4.86296L5.55982 4.88323L6.05468 12.1878L6.35399 12.1675ZM6.01276 12.5553C6.21271 12.5415 6.36676 12.37 6.35404 12.1682L6.05463 12.1871C6.05678 12.2212 6.0305 12.2534 5.99205 12.256L6.01276 12.5553ZM6.00154 12.5557H6.00241V12.2557H6.00154V12.5557ZM8.98987 12.5554L9.4232 12.5803L9.44038 12.2808L9.00705 12.2559L8.98987 12.5554ZM8.99759 12.5557H8.99846V12.2557H8.99759V12.5557ZM8.64596 12.1682C8.63324 12.37 8.78729 12.5415 8.98724 12.5553L9.00795 12.256C8.96949 12.2534 8.94322 12.2212 8.94536 12.1871L8.64596 12.1682ZM9.14087 4.86296L8.646 12.1675L8.94532 12.1878L9.44018 4.88323L9.14087 4.86296ZM9.53025 4.52281C9.32983 4.51051 9.15434 4.661 9.14086 4.86312L9.4402 4.88308C9.44249 4.84872 9.47313 4.81986 9.51187 4.82224L9.53025 4.52281ZM9.96328 4.5485L9.52995 4.52279L9.51218 4.82226L9.94551 4.84797L9.96328 4.5485ZM10.2152 4.67066C10.1508 4.59821 10.0602 4.55446 9.9636 4.54852L9.94518 4.84796C9.96317 4.84906 9.97958 4.8572 9.99096 4.86999L10.2152 4.67066ZM10.306 4.93542C10.3125 4.83845 10.2796 4.74318 10.2152 4.67066L9.99096 4.86999C10.0023 4.88272 10.0078 4.89905 10.0067 4.91534L10.306 4.93542ZM9.81112 12.2401L10.306 4.93552L10.0067 4.91524L9.5118 12.2198L9.81112 12.2401ZM9.42319 12.5803C9.62307 12.5918 9.79764 12.4415 9.81113 12.24L9.51179 12.2199C9.5095 12.2542 9.47902 12.283 9.44039 12.2808L9.42319 12.5803Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </template>
          </delete-confirm>

          <button
            v-if="!hideActions.includes('add-to-blocks') && userRole.includes('superadministrator')"
            class="toolbar-icon-button"
            @click.stop="addToBlocks"
          >
            <i class="fa fa-upload toolbar-upload-icon" />
          </button>
        </div>
      </div>

      <button
        v-if="!hideAddComponent"
        class="toolbar-add-button"
        @click.stop="handleAddComponent"
      >
        <svg
          fill="none"
          height="12"
          viewBox="0 0 12 12"
          width="12"
          xmlns="http://www.w3.org/2000/svg"
          class="toolbar-add-icon"
        >
          <path
            d="M11.4774 5.275V7.175H6.95244V11.7H5.05244V7.175H0.527435V5.275H5.05244V0.75H6.95244V5.275H11.4774Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import DeleteConfirm from '@/components/editor/modals/DeleteConfirm.vue'

export default {
  name: 'Toolbar',
  components: {
    DeleteConfirm
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    hovered: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'block'
    },
    hideControls: {
      type: Boolean,
      default: false
    },
    hideControlsLeft: {
      type: Boolean,
      default: false
    },
    hideControlsRight: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Array,
      default: () => ['add-to-blocks']
    },
    hideAddComponent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFocus: false
    }
  },
  computed: {
    ...mapGetters('auth', {
      userRole: 'userRole'
    }),
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdatePages () {
      return this.checkPermissions('pages.update')
    },
    label: {
      get () {
        return _.startCase(this.value)
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleClick (e) {
      // this.$emit('flow')
      this.$emit('highlight-click')
      this.$emit('click-inside', e)
    },
    handleMousemove (e) {
      if (window.isDrag) return

      if (e.target.closest('.toolbar-overlay') === this.$el) {
        this.isActive = true
      } else {
        this.isActive = false
        this.isFocus = false
      }
    },
    handleMouseleave () {
      if (this.isFocus) return
      this.isActive = false
    },
    handleAddComponent () {
      this.$emit('add-subject')
    },
    handleDuplicate () {
      this.$emit('dublicate')
    },
    handleMoveUp () {
      this.$emit('move-to', 'up')
    },
    handleMoveDown () {
      this.$emit('move-to', 'down')
    },
    handleFavorite () {
      this.$emit('favorite')
    },
    handleDelete () {
      this.$emit('delete')
    },
    addToBlocks () {
      this.$emit('add-to-blocks')
    }
  }
}
</script>

<style scoped>
.toolbar-overlay {
  opacity: 0;
  position: absolute;
  inset: 0;
  z-index: 1000;
  pointer-events: none;

  &.active {
    opacity: 1;
  }

  &.pressed {
    z-index: 1005;
  }
}

.toolbar-frame {
  position: relative;
  width: 100%;
  height: 100%;
}

.toolbar-header {
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
  height: 28px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  column-gap: 1rem;
  color: #fff;
}

.toolbar-header,
.toolbar-add-button {
  pointer-events: auto;
}

.toolbar-header-left,
.toolbar-header-right {
  height: 100%;
  display: inline-flex;
  align-items: center;
  padding: 0 0.625rem;
  border-radius: 4px 4px 0 0;
}

.toolbar-header-left {
  justify-content: flex-start;
  column-gap: 0.5rem;
}

.toolbar-header-right {
  justify-content: flex-end;
  column-gap: 0.875rem;
}

.toolbar-icon {
  width: 1rem;
  height: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s ease;
}

.toolbar-icon--drag {
  cursor: move;
}

.toolbar-icon-svg {
  width: 0.875rem;
  height: 0.875rem;
}

.toolbar-icon-svg-up {
  width: 0.75rem;
  height: 0.75rem;
}

.toolbar-icon-svg-down {
  width: 0.75rem;
  height: 0.75rem;
}

.toolbar-icon-button {
  width: 1rem;
  height: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.toolbar-icon-button:hover,
.toolbar-icon:hover {
  opacity: 0.8;
}

.toolbar-upload-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.toolbar-move-buttons {
  display: inline-flex;
  align-items: center;
  column-gap: 0.125rem;
}

.toolbar-name-input {
  font-size: 0.75rem;
  text-transform: uppercase;
  width: 100%;
  max-width: 7rem;
  background: transparent;
  border: none;
  color: inherit;
  outline: none;
}

.toolbar-add-button {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
  width: 30px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #fff;
  cursor: pointer;
}

.toolbar-add-icon {
  width: 0.75rem;
  height: 0.75rem;
}

.el-block {
  --block-color: #82cec9;

  .toolbar-frame {
    box-shadow: 0 0 0 2px var(--block-color);
  }

  .toolbar-header-left,
  .toolbar-header-right {
    background: var(--block-color);
    box-shadow: 0 0 0 2px var(--block-color);
  }

  .toolbar-add-button {
    border: 2px solid var(--block-color);
  }

  .toolbar-add-icon {
    color: var(--block-color);
  }
}

.el-row {
  --row-color: #7cacfa;

  .toolbar-frame {
    box-shadow: 0 0 0 2px var(--row-color);
  }

  .toolbar-header-left,
  .toolbar-header-right {
    background: var(--row-color);
    box-shadow: 0 0 0 2px var(--row-color);
  }

  .toolbar-add-button {
    border: 2px solid var(--row-color);
  }

  .toolbar-add-icon {
    color: var(--row-color);
  }
}

.el-col {
  --col-color: #3f51b5;

  .toolbar-frame {
    box-shadow: 0 0 0 2px var(--col-color);
  }

  .toolbar-header-left,
  .toolbar-header-right {
    background: var(--col-color);
    box-shadow: 0 0 0 2px var(--col-color);
  }

  .toolbar-add-button {
    border: 2px solid var(--col-color);
  }

  .toolbar-add-icon {
    color: var(--col-color);
  }
}

.el-element {
  --element-color: #62ad62;

  .toolbar-frame {
    box-shadow: 0 0 0 2px var(--element-color);
  }

  .toolbar-header-left,
  .toolbar-header-right {
    background: var(--element-color);
    box-shadow: 0 0 0 2px var(--element-color);
  }

  .toolbar-add-button {
    border: 2px solid var(--element-color);
  }

  .toolbar-add-icon {
    color: var(--element-color);
  }
}

.el-dynamic {
  --dynamic-color: #6433A2;

  .toolbar-frame {
    box-shadow: 0 0 0 2px var(--dynamic-color);
  }

  .toolbar-header-left,
  .toolbar-header-right {
    background: var(--dynamic-color);
    box-shadow: 0 0 0 2px var(--dynamic-color);
  }

  .toolbar-add-button {
    border: 2px solid var(--dynamic-color);
  }

  .toolbar-add-icon {
    color: var(--dynamic-color);
  }
}
</style>